import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Subheading = styled(Typography)(({ theme }) => ({
  color: theme.palette.grayscale[700],
}));
